<template>
  <div class="account-sidebar">
    <div class="sidebar-tabs">
      <div class="sidebar-nav">
        <div v-for="item in menuItems" :key="item.id" class="sidebar-item" :class="{
          'active': isItemActive(item),
          'has-sidebar-dropdown': item.children
        }">
          <div class="sidebar-item-header" @click="item.children ? toggleDropdown(item.id) : selectTab(item.type)">
            <span class="sidebar-label">{{ item.label }}</span>
            <span v-if="item.children" class="sidebar-dropdown-arrow" :class="{ 'open': shouldShowDropdown(item) }">
              <img src="@/assets/icons/arrow_down_black.svg" alt="arrow" />
            </span>
          </div>
          <div v-if="item.children && shouldShowDropdown(item)" class="sidebar-dropdown-menu">
            <div v-for="child in item.children" :key="child.id" class="sidebar-dropdown-item"
              :class="{ 'active': switch_tab === child.type }" @click="selectTab(child.type)">
              <span class="sidebar-label">{{ child.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "account-sidebar",
  components: {},
  props: {
    switch_tab: {
      type: String,
      default: "",
    },
    account: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => {
    return {
      openDropdowns: [],
      menuItems: [
        { id: 1, type: 'overview', label: 'Overview' },
        // { id: 2, type: 'projects', label: 'Projects' },
        {
          id: 3,
          type: 'contacts',
          label: 'Contacts',
          children: [
            { id: 31, type: 'account-contact', label: 'Account Contact' },
            { id: 32, type: 'lia-generation', label: 'Lia Generation' }
          ]
        },
        { id: 4, type: 'attachments', label: 'Attachements' },
        { id: 5, type: 'notes', label: 'Notes' },
        { id: 6, type: 'activities', label: 'Activities' }
      ]
    };
  },
  created() {
    // Initialize dropdowns based on active tab
    this.initializeDropdowns();
  },
  methods: {
    initializeDropdowns() {
      const activeParent = this.menuItems.find(item =>
        item.children?.some(child => child.type === this.switch_tab)
      );
      if (activeParent && !this.openDropdowns.includes(activeParent.id)) {
        this.openDropdowns.push(activeParent.id);
      }
    },
    isItemActive(item) {
      if (item.type === this.switch_tab) return true;
      return item.children?.some(child => child.type === this.switch_tab) || false;
    },
    shouldShowDropdown(item) {
      return this.openDropdowns.includes(item.id) || this.isItemActive(item);
    },
    toggleDropdown(itemId) {
      const index = this.openDropdowns.indexOf(itemId);
      const item = this.menuItems.find(i => i.id === itemId);

      if (index === -1) {
        this.openDropdowns.push(itemId);
      } else if (!this.isItemActive(item)) {
        this.openDropdowns.splice(index, 1);
      }
    },
    selectTab(type) {
      let vm = this;

      let path = [
        {
          label: "Accounts",
          path: "/accounts/list",
        }
      ];


      // Add account name at the end
      if (vm.account.name) {
        path.push({
          label: vm.account.name,
          active: true,
        });
      }

      vm.$store.commit("SET_PATH", path);
      vm.$router
        .push({
          name: "account-view",
          params: { type: type, id: vm.$route.params.id },
        })
        .catch((error) => { });
    },
  },
  watch: {
    switch_tab: {
      handler(newVal) {
        this.initializeDropdowns();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.account-sidebar {
  display: flex;
  flex-direction: column;
  background: #fff;
  width: 134px;
  height: max-content;
  border-bottom: 1px solid #efefef;
  border-radius: 5px;
  overflow: visible;
  margin-right: 5px;
  padding: 12px 16px;

  @media (min-width: 300px) and (max-width: 630px) {
    flex-direction: row;
    justify-content: center;
  }

  .sidebar-tabs {
    height: calc(100% - 168px);

    @media (min-width: 300px) and (max-width: 630px) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: unset;
      overflow-y: unset;
    }

    .sidebar-nav {
      .sidebar-item {
        cursor: pointer;
        position: relative;

        .sidebar-item-header {
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-right: 8px;
        }

        @media (min-width: 300px) and (max-width: 630px) {
          font-size: 11px;
        }

        .sidebar-label {
          display: block;
          color: #707070;

          @media (min-width: 300px) and (max-width: 630px) {
            display: none;
          }
        }

        .sidebar-dropdown-arrow {
          display: flex;
          align-items: center;
          transition: transform 0.3s ease;

          img {
            width: 12px;
            height: 12px;
          }

          &.open {
            transform: rotate(-180deg);
          }
        }

        .sidebar-dropdown-menu {
          background: #fff;

          .sidebar-dropdown-item {
            height: 35px;
            display: flex;
            align-items: center;
            padding-left: 20px;
            white-space: nowrap;
            transition: all 0.3s ease;

            &:hover {
              background-color: #f5f5f5;

              .sidebar-label {
                color: #1ba5a4;
              }
            }

            &.active {
              .sidebar-label {
                color: #1ba5a4 !important;
                font-weight: 500;
              }
            }

            .sidebar-label {
              display: block !important;
              font-size: 0.9em;
              transition: color 0.3s ease;

              @media (min-width: 300px) and (max-width: 630px) {
                display: block !important;
              }
            }
          }
        }

        &.active {
          >.sidebar-item-header {
            .sidebar-label {
              color: #1ba5a4;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
</style>
